import { language } from "@chef/constants";

export const intl = (
  {
    no: { BACK_TO_TOP: "Tilbake til toppen" },
    se: { BACK_TO_TOP: "Tilbaka till toppen" },
    dk: { BACK_TO_TOP: "Tilbage til toppen" },
  } as const
)[language];
